
// ----------------------------
// src/views/bookFilter.component.js
// Manage the book filter view
//
// DO NOT EDIT THIS FILE WITHIN READS. YOUR CHANGES WILL BE OVERWRITTEN BY READSMANAGE DURING THE EXPORTING PROCESS.
// READSMANAGE GENERATES A STATIC VERSION OF THE FILTERS.

"use strict";

const BOOK_FILTER_TEMPLATE = `
<div class="filterWrapper col-lg-12 col-sm-12 col-xs-12 col-md-12 bg-purple">
    <h3><%= app.localeManager.get("filters.theme") %></h3>
    <div id="themeFilter" class="filter col-lg-12 col-md-12 col-sm-12 col-xs-12" data-filterType="theme">
        <ul>
                            <li class="filterListItem" data-filter="Adventure">
                    <%= app.localeManager.get("themes.adventure") %>
                    <span>(75)</span>
                </li>
                            <li class="filterListItem" data-filter="Animals">
                    <%= app.localeManager.get("themes.animals") %>
                    <span>(246)</span>
                </li>
                            <li class="filterListItem" data-filter="Body">
                    <%= app.localeManager.get("themes.body") %>
                    <span>(20)</span>
                </li>
                            <li class="filterListItem" data-filter="Colours">
                    <%= app.localeManager.get("themes.colours") %>
                    <span>(9)</span>
                </li>
                            <li class="filterListItem" data-filter="Family and Friends">
                    <%= app.localeManager.get("themes.family and friends") %>
                    <span>(189)</span>
                </li>
                            <li class="filterListItem" data-filter="Feelings and Values">
                    <%= app.localeManager.get("themes.feelings and values") %>
                    <span>(110)</span>
                </li>
                            <li class="filterListItem" data-filter="Food">
                    <%= app.localeManager.get("themes.food") %>
                    <span>(29)</span>
                </li>
                            <li class="filterListItem" data-filter="Games and Sports">
                    <%= app.localeManager.get("themes.games and sports") %>
                    <span>(26)</span>
                </li>
                            <li class="filterListItem" data-filter="Imagination">
                    <%= app.localeManager.get("themes.imagination") %>
                    <span>(75)</span>
                </li>
                            <li class="filterListItem" data-filter="Nature">
                    <%= app.localeManager.get("themes.nature") %>
                    <span>(45)</span>
                </li>
                            <li class="filterListItem" data-filter="Numbers">
                    <%= app.localeManager.get("themes.numbers") %>
                    <span>(14)</span>
                </li>
                            <li class="filterListItem" data-filter="Other Themes">
                    <%= app.localeManager.get("themes.other themes") %>
                    <span>(230)</span>
                </li>
                            <li class="filterListItem" data-filter="Outer Space">
                    <%= app.localeManager.get("themes.outer space") %>
                    <span>(3)</span>
                </li>
                            <li class="filterListItem" data-filter="Places">
                    <%= app.localeManager.get("themes.places") %>
                    <span>(37)</span>
                </li>
                            <li class="filterListItem" data-filter="School">
                    <%= app.localeManager.get("themes.school") %>
                    <span>(31)</span>
                </li>
                    </ul>
    </div>
</div>
<div class="filterWrapper col-lg-12 col-sm-12 col-xs-12 col-md-12 bg-pink">
    <h3><%= app.localeManager.get("filters.language") %></h3>
    <div id="languageFilter" class="filter col-lg-12 col-md-12 col-sm-12 col-xs-12" data-filterType="language">
        <ul>
                            <li class="filterListItem" data-filter="English">
                    <%= app.localeManager.get("languages.english") %>
                    <span>(882)</span>
                </li>
                            <li class="filterListItem" data-filter="French">
                    <%= app.localeManager.get("languages.french") %>
                    <span>(302)</span>
                </li>
                            <li class="filterListItem" data-filter="Kiswahili">
                    <%= app.localeManager.get("languages.kiswahili") %>
                    <span>(195)</span>
                </li>
                            <li class="filterListItem" data-filter="Afrikaans">
                    <%= app.localeManager.get("languages.afrikaans") %>
                    <span>(58)</span>
                </li>
                            <li class="filterListItem" data-filter="Assamese">
                    <%= app.localeManager.get("languages.assamese") %>
                    <span>(10)</span>
                </li>
                            <li class="filterListItem" data-filter="Ateso">
                    <%= app.localeManager.get("languages.ateso") %>
                    <span>(8)</span>
                </li>
                            <li class="filterListItem" data-filter="Bangla">
                    <%= app.localeManager.get("languages.bangla") %>
                    <span>(24)</span>
                </li>
                            <li class="filterListItem" data-filter="Bengali">
                    <%= app.localeManager.get("languages.bengali") %>
                    <span>(105)</span>
                </li>
                            <li class="filterListItem" data-filter="Chinese, Simplified">
                    <%= app.localeManager.get("languages.chinese, simplified") %>
                    <span>(89)</span>
                </li>
                            <li class="filterListItem" data-filter="Chinese, Traditional">
                    <%= app.localeManager.get("languages.chinese, traditional") %>
                    <span>(54)</span>
                </li>
                            <li class="filterListItem" data-filter="ChiTonga">
                    <%= app.localeManager.get("languages.chitonga") %>
                    <span>(12)</span>
                </li>
                            <li class="filterListItem" data-filter="Ekegusii">
                    <%= app.localeManager.get("languages.ekegusii") %>
                    <span>(15)</span>
                </li>
                            <li class="filterListItem" data-filter="Fulfulde">
                    <%= app.localeManager.get("languages.fulfulde") %>
                    <span>(17)</span>
                </li>
                            <li class="filterListItem" data-filter="Gujarati">
                    <%= app.localeManager.get("languages.gujarati") %>
                    <span>(14)</span>
                </li>
                            <li class="filterListItem" data-filter="Hausa">
                    <%= app.localeManager.get("languages.hausa") %>
                    <span>(18)</span>
                </li>
                            <li class="filterListItem" data-filter="Hindi">
                    <%= app.localeManager.get("languages.hindi") %>
                    <span>(29)</span>
                </li>
                            <li class="filterListItem" data-filter="isiNdebele">
                    <%= app.localeManager.get("languages.isindebele") %>
                    <span>(17)</span>
                </li>
                            <li class="filterListItem" data-filter="isiXhosa">
                    <%= app.localeManager.get("languages.isixhosa") %>
                    <span>(23)</span>
                </li>
                            <li class="filterListItem" data-filter="isiZulu">
                    <%= app.localeManager.get("languages.isizulu") %>
                    <span>(54)</span>
                </li>
                            <li class="filterListItem" data-filter="Kannada">
                    <%= app.localeManager.get("languages.kannada") %>
                    <span>(20)</span>
                </li>
                            <li class="filterListItem" data-filter="Kanuri">
                    <%= app.localeManager.get("languages.kanuri") %>
                    <span>(16)</span>
                </li>
                            <li class="filterListItem" data-filter="Kikamba">
                    <%= app.localeManager.get("languages.kikamba") %>
                    <span>(34)</span>
                </li>
                            <li class="filterListItem" data-filter="Kinyarwanda">
                    <%= app.localeManager.get("languages.kinyarwanda") %>
                    <span>(63)</span>
                </li>
                            <li class="filterListItem" data-filter="Lingala">
                    <%= app.localeManager.get("languages.lingala") %>
                    <span>(13)</span>
                </li>
                            <li class="filterListItem" data-filter="Luganda">
                    <%= app.localeManager.get("languages.luganda") %>
                    <span>(53)</span>
                </li>
                            <li class="filterListItem" data-filter="Lugbarati">
                    <%= app.localeManager.get("languages.lugbarati") %>
                    <span>(39)</span>
                </li>
                            <li class="filterListItem" data-filter="Lumasaaba">
                    <%= app.localeManager.get("languages.lumasaaba") %>
                    <span>(26)</span>
                </li>
                            <li class="filterListItem" data-filter="Lunyole">
                    <%= app.localeManager.get("languages.lunyole") %>
                    <span>(31)</span>
                </li>
                            <li class="filterListItem" data-filter="Lusoga">
                    <%= app.localeManager.get("languages.lusoga") %>
                    <span>(47)</span>
                </li>
                            <li class="filterListItem" data-filter="Maa">
                    <%= app.localeManager.get("languages.maa") %>
                    <span>(28)</span>
                </li>
                            <li class="filterListItem" data-filter="Marathi">
                    <%= app.localeManager.get("languages.marathi") %>
                    <span>(20)</span>
                </li>
                            <li class="filterListItem" data-filter="Ng&#039;aturkana">
                    <%= app.localeManager.get("languages.ng&#039;aturkana") %>
                    <span>(31)</span>
                </li>
                            <li class="filterListItem" data-filter="Odia">
                    <%= app.localeManager.get("languages.odia") %>
                    <span>(21)</span>
                </li>
                            <li class="filterListItem" data-filter="Oluwanga">
                    <%= app.localeManager.get("languages.oluwanga") %>
                    <span>(30)</span>
                </li>
                            <li class="filterListItem" data-filter="Portuguese">
                    <%= app.localeManager.get("languages.portuguese") %>
                    <span>(30)</span>
                </li>
                            <li class="filterListItem" data-filter="Punjabi">
                    <%= app.localeManager.get("languages.punjabi") %>
                    <span>(10)</span>
                </li>
                            <li class="filterListItem" data-filter="Sepedi">
                    <%= app.localeManager.get("languages.sepedi") %>
                    <span>(16)</span>
                </li>
                            <li class="filterListItem" data-filter="Sesotho">
                    <%= app.localeManager.get("languages.sesotho") %>
                    <span>(29)</span>
                </li>
                            <li class="filterListItem" data-filter="Setswana">
                    <%= app.localeManager.get("languages.setswana") %>
                    <span>(22)</span>
                </li>
                            <li class="filterListItem" data-filter="Tamil">
                    <%= app.localeManager.get("languages.tamil") %>
                    <span>(13)</span>
                </li>
                            <li class="filterListItem" data-filter="Telugu">
                    <%= app.localeManager.get("languages.telugu") %>
                    <span>(35)</span>
                </li>
                            <li class="filterListItem" data-filter="Urdu">
                    <%= app.localeManager.get("languages.urdu") %>
                    <span>(19)</span>
                </li>
                            <li class="filterListItem" data-filter="Zarma">
                    <%= app.localeManager.get("languages.zarma") %>
                    <span>(8)</span>
                </li>
                    </ul>
    </div>
</div>
<div class="filterWrapper col-lg-12 col-sm-12 col-xs-12 col-md-12 bg-yellow">
    <h3><%= app.localeManager.get("filters.country") %></h3>
    <div id="countryFilter" class="filter col-lg-12 col-md-12 col-sm-12 col-xs-12" data-filterType="country">
        <ul>
                            <li class="filterListItem" data-filter="Canada">
                    <%= app.localeManager.get("country.canada")%>
                    <span>(34)</span>
                </li>
                            <li class="filterListItem" data-filter="Kenya">
                    <%= app.localeManager.get("country.kenya")%>
                    <span>(42)</span>
                </li>
                            <li class="filterListItem" data-filter="Australia">
                    <%= app.localeManager.get("country.australia")%>
                    <span>(14)</span>
                </li>
                            <li class="filterListItem" data-filter="China">
                    <%= app.localeManager.get("country.china")%>
                    <span>(74)</span>
                </li>
                            <li class="filterListItem" data-filter="Ethiopia">
                    <%= app.localeManager.get("country.ethiopia")%>
                    <span>(2)</span>
                </li>
                            <li class="filterListItem" data-filter="France">
                    <%= app.localeManager.get("country.france")%>
                    <span>(11)</span>
                </li>
                            <li class="filterListItem" data-filter="Germany">
                    <%= app.localeManager.get("country.germany")%>
                    <span>(1)</span>
                </li>
                            <li class="filterListItem" data-filter="Ghana">
                    <%= app.localeManager.get("country.ghana")%>
                    <span>(5)</span>
                </li>
                            <li class="filterListItem" data-filter="India">
                    <%= app.localeManager.get("country.india")%>
                    <span>(225)</span>
                </li>
                            <li class="filterListItem" data-filter="Iran">
                    <%= app.localeManager.get("country.iran")%>
                    <span>(4)</span>
                </li>
                            <li class="filterListItem" data-filter="Lesotho">
                    <%= app.localeManager.get("country.lesotho")%>
                    <span>(5)</span>
                </li>
                            <li class="filterListItem" data-filter="Mozambique">
                    <%= app.localeManager.get("country.mozambique")%>
                    <span>(6)</span>
                </li>
                            <li class="filterListItem" data-filter="Nigeria">
                    <%= app.localeManager.get("country.nigeria")%>
                    <span>(33)</span>
                </li>
                            <li class="filterListItem" data-filter="Russia">
                    <%= app.localeManager.get("country.russia")%>
                    <span>(1)</span>
                </li>
                            <li class="filterListItem" data-filter="Saudi Arabia">
                    <%= app.localeManager.get("country.saudi arabia")%>
                    <span>(7)</span>
                </li>
                            <li class="filterListItem" data-filter="South Africa">
                    <%= app.localeManager.get("country.south africa")%>
                    <span>(273)</span>
                </li>
                            <li class="filterListItem" data-filter="Sri Lanka">
                    <%= app.localeManager.get("country.sri lanka")%>
                    <span>(14)</span>
                </li>
                            <li class="filterListItem" data-filter="Tanzania">
                    <%= app.localeManager.get("country.tanzania")%>
                    <span>(10)</span>
                </li>
                            <li class="filterListItem" data-filter="Uganda">
                    <%= app.localeManager.get("country.uganda")%>
                    <span>(37)</span>
                </li>
                            <li class="filterListItem" data-filter="UK">
                    <%= app.localeManager.get("country.uk")%>
                    <span>(22)</span>
                </li>
                            <li class="filterListItem" data-filter="Unknown">
                    <%= app.localeManager.get("country.unknown")%>
                    <span>(1)</span>
                </li>
                            <li class="filterListItem" data-filter="USA">
                    <%= app.localeManager.get("country.usa")%>
                    <span>(75)</span>
                </li>
                            <li class="filterListItem" data-filter="Yemen">
                    <%= app.localeManager.get("country.yemen")%>
                    <span>(1)</span>
                </li>
                    </ul>
    </div>
</div>
<div class="filterWrapper col-lg-12 col-sm-12 col-xs-12 col-md-12 bg-green">
    <h3><%= app.localeManager.get("filters.level") %></h3>
    <div id="reading_levelFilter" class="filter col-lg-12 col-md-12 col-sm-12 col-xs-12"
         data-filterType="reading_level">
        <ul>
                            <li class="filterListItem" data-filter="Advanced">
                    <%= app.localeManager.get("levels.advanced")%>
                    <span>(71)</span>
                </li>
                            <li class="filterListItem" data-filter="Average">
                    <%= app.localeManager.get("levels.average")%>
                    <span>(223)</span>
                </li>
                            <li class="filterListItem" data-filter="Beginner">
                    <%= app.localeManager.get("levels.beginner")%>
                    <span>(262)</span>
                </li>
                            <li class="filterListItem" data-filter="Easy">
                    <%= app.localeManager.get("levels.easy")%>
                    <span>(329)</span>
                </li>
                            <li class="filterListItem" data-filter="Expert">
                    <%= app.localeManager.get("levels.expert")%>
                    <span>(12)</span>
                </li>
                    </ul>
    </div>
</div>
<div class="filterWrapper col-lg-12 col-sm-12 col-xs-12 col-md-12 bg-bright-blue">
    <h3><%= app.localeManager.get("filters.type") %></h3>
    <div id="typeFilter" class="filter col-lg-12 col-md-12 col-sm-12 col-xs-12" data-filterType="type">
        <ul>
                            <li class="filterListItem" data-filter="Fiction">
                    <%= app.localeManager.get("types.fiction")%>
                    <span>(863)</span>
                </li>
                            <li class="filterListItem" data-filter="Non-fiction">
                    <%= app.localeManager.get("types.non-fiction")%>
                    <span>(8)</span>
                </li>
                            <li class="filterListItem" data-filter="Poetry">
                    <%= app.localeManager.get("types.poetry")%>
                    <span>(26)</span>
                </li>
                    </ul>
    </div>
</div>
<div class="filterWrapper col-lg-12 col-sm-12 col-xs-12 col-md-12 bg-orange">
    <h3><%= app.localeManager.get("filters.format") %></h3>
    <div id="formatFilter" class="filter col-lg-12 col-md-12 col-sm-12 col-xs-12" data-filterType="format">
        <ul>
            <li class="filterListItem" data-filter="Audio">Audio<span>(<%= this.countDistinct('audiobook') %>)</span>
            </li>
            <li class="filterListItem" data-filter="HTML">HTML<span>(<%= this.countDistinct('html') %>)</span></li>
            <li class="filterListItem" data-filter="PDF">PDF<span>(<%= this.countDistinct('pdf') %>)</span></li>
        </ul>
    </div>
</div>
<div class="clearfix"></div>
`;

const BookFilterComponent = Backbone.View.extend({

id: "filters",

className: "col-lg-12 p0 animated",

active: {
"country": [],
"format": [],
"language": [],
"reading_level": [],
"theme": [],
"type": []
},

cachedResults: {
audiobook: null,
pdf: null,
html: null
},

// Reference to all the tables in the database that can be filtered
filters: ["theme", "language", "country", "reading_level", "type", "format"],
// The filters with their content
tables: {},
// Base url used to redirect the user
baseURL: "findBy/",
// The query string added to the base URL
query: "",

template: _.template(BOOK_FILTER_TEMPLATE),

events: {
"click .filterWrapper h3": "expandFilter",
"click li.filterListItem": "updateSelection",
},

initialize: function() {
var self;

// Reference to the BookFilterComponent object
self = this;
// Loop through every filters to fill their content
this.filters.forEach(function(filter){
self.tables[filter] = {};
self.tables[filter].column = filter.ucfirst();
self.tables[filter].values = [];
$("#" + filter + "Filter").find("ul li")
.each(function(i, el) {
// The table name is taken from the HTML. We need to remove the "(numbers)" pattern.
// Otherwise, the filter won't work.
self.tables[filter].values.push($(el).data("filter"));
});
});
},

countDistinct: function(attribute) {
// counts the number of books for a given property
// e.g. the number of books available in pdf, html and audiobook
if (this.cachedResults.hasOwnProperty(attribute)) {
if (this.cachedResults[attribute] === null) {
let nbBooks = 0;

window.BOOKCOLLECTION.each(function(model) {
if (Array.isArray(model.get(attribute)) && model.get(attribute).length > 0) {
nbBooks++;
}
});
this.cachedResults[attribute] = nbBooks;
}

return this.cachedResults[attribute];
}

return 0;
},

render: function() {
this.$el.html(this.template());

return this;
},

// Add a filter string to the active filters array
add: function(filterType, value) {
// If the element is not already present then add it
if (this.active[filterType].indexOf(value) === -1) {
this.active[filterType].push(value);
}
},

// Close the filter menu
close: function() {
app.resume();
this.$el.fadeOut("fast");
new TimelineMax().staggerTo("#filterMenuForm li", 0.5, { y: 80, ease: Power2.easeOut }, 0.1);
},

computeFilterWrapperHeight: function(jQueryElements) {
jQueryElements.each(function(i, el) {
// 33 = margin-top; 23 = margin-bottom
// both are css properties of the filterWrapper element
$(el).height($(el).find("h3").outerHeight() + 33 + 23);
});
},

// Effectively filters books from a given BookCollection
exec: function(bookCollection) {
let finalCollection, books;

finalCollection = bookCollection;
for (let key in this.active) {
if (this.active[key].length > 0) {
books = finalCollection.filterBy(key, this.active[key]);
finalCollection = new BookCollection(books.models)
.clean()
.randomize();
}
}

return finalCollection;
},

// Expand a specific filter when clicked on to see its values
expandFilter: function(e) {
if (!$(e.target).parent().hasClass("open")) {
// Toggle the 'open' class
$(e.target).parent().toggleClass("open");
// Calculate the required height
var height = $(e.target).parent().find(".filter").height() + $(e.target).parent().height() + 20;
// Set the height of the parent
$(e.target).parent().height(height);
} else {
// Toggle the 'open' class
$(e.target).parent().toggleClass("open");
this.computeFilterWrapperHeight($(e.target).parent());
}
},

// Checks if the value exists in a table within the tables parameter
// (eg. "Space" from Theme)
isPresent: function(table, value) {
if (typeof(this.tables[table]) !== "undefined" || this.tables[table] !== null) {
return this.tables[table].values.some(function(element) {
return element === value;
});
}
},

// Open the filter menu form with animation
open: function() {
app.disable();
this.$el.show();
this.computeFilterWrapperHeight(this.$el.find(".filterWrapper"));
this.$el.animateCssIn("bounceInDown");
},

// Removes a filter string from the active filters array
remove: function(filterType, value) {
var activeRow;

filterType = filterType.toLowerCase();
activeRow = this.active[filterType];
// If the element exists then remove it
if (this.active[filterType].indexOf(value) !== -1) {
activeRow.splice(activeRow.indexOf(value), 1);
this.$el.find("li[data-filter='" + value.replace(/'/g, "\\'") + "']")
.removeClass("active");
}
},

// Removes a filter string by index from the active filters array
removeByIndex: function(filterType, index) {
var activeRow;
var value;

filterType = filterType.toLowerCase();
activeRow = this.active[filterType];
// If the element exists then remove it
if (typeof this.active[filterType][index] !== "undefined") {
value = this.active[filterType][index]; // get value before splice!
activeRow.splice(index, 1);
this.$el.find("li[data-filter='" + value.replace(/'/g, "\\'") + "']")
.removeClass("active");
}
},

// Removes a filter selection and applies the changes
removeSelection: function(filterType, value) {
this.remove(filterType, value);
this.submitFilters();
},

// Removes a filter selection by index and applies the changes
removeSelectionByIndex: function(filterType, index) {
this.removeByIndex(filterType, index);
this.submitFilters();
},

// Resets the query to an empty string i.e removing every activated filter
resetFilters: function() {
var key;

for (key in this.active) {
this.active[key] = [];
}
this.resetQuery();
this.uncheck();

app.router.navigate("#" + app.getLanguage() + "/" + this.query, { trigger: true, replace: false })
},

// Resets the query parameter to its original value
resetQuery: function() {
this.query = this.baseURL + "";
},

// Submits the user selection and filter the books
submitFilters: function() {
var table, value, key;

// Reset the query parameter
this.resetQuery();
// Loop through every table
for (key in this.active) {
table = this.active[key];
// If the table has active elements (i.e. the clicked <li> tags)
    // then add them to the query string
    if (table.length > 0) {
    // Convert the active array to a string
    value = _.uniq(table).join("||");
    // Add that string to the query string
    this.query += key + "=" + value + "&&";
    }
    }
    // Calls the method that will filter the books
    app.router.navigate("#" + app.getLanguage() + "/" + this.query, { trigger: true, replace: false });
    },

    // Adds or removes a filter string from the active filters array
    sync: function(filter) {
    var key, table;

    for (key in this.active) {
    table = this.active[key];
    if (this.isPresent(key, filter)) {
    if (table.active.indexOf(filter) !== -1) {
    this.active[key].splice(table.indexOf(filter), 1);
    } else {
    table.splice(table.indexOf(filter), 0, filter);
    }
    }
    }
    },

    // Unchecks all the filters
    uncheck: function() {
    this.$el.find(".filterListItem").removeClass("active");
    },

    // Update the selection based on the active span(s) in the filter menu
    updateSelection: function(e) {
    var $filter, value, filterType;

    // Get the selected filter DOM element and its value
    $filter = $(e.currentTarget);
    value = $filter.attr("data-filter");
    $filter.toggleClass("active");
    filterType = $filter.parents(".filter").attr("data-filterType");

    // Add the filter to the list of active filters if it's selected or remove it otherwise
    if ($filter.hasClass("active")) {
    this.add(filterType, value);
    } else {
    this.remove(filterType, value);
    }
    },

    updateView: function(url) {
    // Declare variables
    var urlParser, property, values, jTag, self;

    // Parse the URL and get the parameters in a key => value fashion
    self = this;
    urlParser = new UrlParser(url);
    values = urlParser.getValues();
    // Loop through all the filters and find the li tag that corresponds to it
    for (property in values) {
    // Loop through every li tag from one filter
    $("#" + property + "Filter").find("ul li")
    .each(function(i, li) {
    jTag = $(li);
    // If the text of the li tag matches the value of the filter then
    // add the "active" class
    values[property].forEach(function(value) {
    if (jTag.attr("data-filter") === value) {
    self.add(property, value);
    jTag.addClass("active");
    }
    });
    });
    }
    },
    });

    // When the window is being resized close the filters
    window.addEventListener("resize", function() {
    var ua, target;

    ua = navigator.userAgent.toLowerCase();
    if (/android/i.test(ua) || /ipad/i.test(ua) || /iphone os 3_1_2/i.test(ua) || /iphone/i.test(ua)) {
    return;
    }
    target = $("#filters").find(".open");
    if (target.length > 0) {
    $(target).toggleClass("open");
    $(target).removeStyle("height");
    }
    });
